import { Pipe, PipeTransform } from '@angular/core';
import { TimeSlotSeriesData } from '@dr-customer-offers-ui/lib-interfaces';

@Pipe({
  name: 'findBySeriesName',
  pure: true,
  standalone: true
})
export class FindBySeriesNamePipe implements PipeTransform {
  transform(seriesName: string, data?: TimeSlotSeriesData[], ): string {
    if(!data) return '';
    const item = data?.find((item: TimeSlotSeriesData) => item.seriesName === seriesName);
    return item?.value?.toString() ?? '';
  }
}
